// extracted by mini-css-extract-plugin
export default {"welcome-subdiv":"DAshboardOptions_welcome-subdiv__T+3sw","noPrint":"DAshboardOptions_noPrint__5PZ4U"};